module.exports = __webpack_public_path__ + "static/media/product-video.941ec223.svg";